if (!customElements.get("are-you-blushing-slider")) {
  class AreYouBlushingSlider extends HTMLElement {
    constructor() {
      super();
      this.videos = [];
    }

    connectedCallback() {
      this.initSlider();
      this.initVideoControls();
      this.bindVideoControls();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      this.slider = this.querySelector(".swiper");

      const prevEl = this.querySelector(".are-you-blushing__arrow--prev");
      const nextEl = this.querySelector(".are-you-blushing__arrow--next");
      const enableAutoscroll = this.hasAttribute("data-autoscroll");
      const autoscrollDelay = Number(this.getAttribute("data-autoscroll-delay")) || 3000;

      const swiperOptions = {
        slidesPerView: "auto",
        spaceBetween: 16,

        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,

        freeMode: {
          enabled: true,
          sticky: false,
        },

        cssMode: false,

        navigation: {
          prevEl,
          nextEl,
          disabledClass: "swiper-button-disabled",
        },

        watchOverflow: true,

        mousewheel: {
          forceToAxis: true,
        },

        breakpoints: {
          767: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          1024: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      };

      if (enableAutoscroll) {
        swiperOptions.freeMode = false;
        swiperOptions.loop = true;
        swiperOptions.autoplay = {
          delay: autoscrollDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.swiper = new Swiper(this.slider, swiperOptions);
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initVideoControls() {
      const videos = this.querySelectorAll("video");
      if (!videos) return;

      this.videos = Array.from(videos);
    }

    bindVideoControls() {
      if (!this.videos.length) return;

      this.addEventListener("click", (evt) => {
        const videoWrap = evt.target.closest(".are-you-blushing__video");
        if (!videoWrap) return;

        const video = videoWrap.querySelector("video");

        const isPlayPauseClicked = evt.target.closest(
          ".are-you-blushing__play-pause"
        );

        const isMuteClicked = evt.target.closest(".are-you-blushing__mute");

        if (isPlayPauseClicked) {
          this.videos.forEach((videoItem) => {
            if (!videoItem.paused && videoItem !== video) {
              videoItem.pause();

              const wrap = videoItem.closest(".are-you-blushing__video");
              wrap.classList.toggle("are-you-blushing__video--is-paused", true);
            }
          });

          if (video.paused) {
            video.muted = false;
            video.play();
          } else {
            video.pause();
          }

          videoWrap.classList.toggle(
            "are-you-blushing__video--is-paused",
            video.paused
          );

          videoWrap.classList.toggle(
            "are-you-blushing__video--is-muted",
            video.muted
          );
        }

        if (isMuteClicked && !video.paused) {
          video.muted = !video.muted;
          videoWrap.classList.toggle(
            "are-you-blushing__video--is-muted",
            video.muted
          );
        }
      });
    }
  }

  customElements.define("are-you-blushing-slider", AreYouBlushingSlider);
}
